var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;

var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
}); // From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis

function getGlobal() {
  if (typeof globalThis !== "undefined") {
    return globalThis;
  }

  if (typeof self !== "undefined") {
    return self;
  }

  if (typeof window !== "undefined") {
    return window;
  }

  if (typeof _global !== "undefined") {
    return _global;
  }

  return undefined;
}

function getDevTools() {
  var global = getGlobal();

  if (global && "__xstate__" in global) {
    return global.__xstate__;
  }

  return undefined;
}

function registerService(service) {
  if (!getGlobal()) {
    return;
  }

  var devTools = getDevTools();

  if (devTools) {
    devTools.register(service);
  }
}

exports.getGlobal = getGlobal;
exports.registerService = registerService;
export default exports;
export const __esModule = exports.__esModule;
const _getGlobal = exports.getGlobal,
      _registerService = exports.registerService;
export { _getGlobal as getGlobal, _registerService as registerService };